/**
 * Guards de teclado compartilhados da mesa (E37.F1).
 *
 * Dois predicados com semânticas distintas:
 *  - `isTextEntryTarget`: o alvo recebe DIGITAÇÃO (input/textarea/
 *    contentEditable) — atalhos de caractere (+, -, 0, 1, Delete) nunca podem
 *    roubar teclas de quem digita (mesma lição do guard do AnnotationTools).
 *  - `isInteractiveTarget`: além de digitação, inclui controles que ATIVAM com
 *    espaço/enter (button/select) — o pan por espaço não pode sequestrar o
 *    espaço de um botão focado (a11y; mesmo guard do OverlapViewport).
 */
export function isTextEntryTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target.isContentEditable
  );
}

export function isInteractiveTarget(target: EventTarget | null): boolean {
  if (isTextEntryTarget(target)) return true;
  if (!(target instanceof HTMLElement)) return false;
  return target instanceof HTMLButtonElement || target instanceof HTMLSelectElement;
}
